class ApplicationPage extends BaseApplicationPage {
    constructor() {
        super();
        this.backgroundColors = [
            "rgba(54, 162, 235, 0.9)",
            "rgba(255, 159, 64, 0.9)",
            "rgba(75, 192, 192, 0.9)",
            "rgba(255, 205, 86, 0.9)",
            "rgba(153, 102, 255, 0.9)",
            "rgba(201, 203, 207, 0.9)",
            "rgba(255, 99, 132, 0.9)"
        ];
        this.borderColors = [
            "rgba(54, 162, 235, 1)",
            "rgba(255, 159, 64, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(255, 205, 86, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(201, 203, 207, 1)",
            "rgba(255, 99, 132, 1)"
        ];
    }
    initialize() {
        super.initialize();
        // This function is called upon every Ajax update as well as the initial page load.
        // Any custom initiation goes here. 
        this.selectAllCheckbox();
        //spinner for individual checkboxes
        this.activateCheckboxSpinner();
        this.activateProjectCheckboxes();
        //check whether to tick included checkbox
        this.toggleIncludedCheckbox();
        // Janky JS to make nested menu styling work
        $('ul.sidebar-menu > li > ul').addClass('treeview-menu').find('> li.active').closest('ul.sidebar-menu > li').addClass('active');
    }
    activateCheckboxSpinner() {
        $('.included-checkbox').each((i, e) => {
            var input = $(e).find('input[type=checkbox]');
            if (input.hasClass('select-all-items'))
                return;
            input.change((event) => {
                input.prop('disabled', true);
                var loader = input.closest('tr').find('a[name=LoadingIcon]');
                loader.removeClass('hide-icon');
                loader.find('i').addClass('fa-spin fa-spinner');
                var target = $('.select-all-items').attr('data-target');
                this.SaveData(input, input, target);
            });
        });
    }
    activateProjectCheckboxes() {
        $('.included-warning').each((i, e) => {
            var input = $(e).find('input[type=checkbox]');
            if (input.hasClass('select-all-items'))
                return;
            input.change((event) => {
                input.prop('disabled', true);
                var loader = input.closest('tr').find('a[name=LoadingIcon]');
                loader.removeClass('hide-icon');
                loader.find('i').addClass('fa-spin fa-spinner');
                var target = $('#DisableEmailWarnings').attr('data-target');
                this.SaveData(input, input, target);
            });
        });
        $('.included-review').each((i, e) => {
            var input = $(e).find('input[type=checkbox]');
            if (input.hasClass('select-all-items'))
                return;
            input.change((event) => {
                input.prop('disabled', true);
                var loader = input.closest('tr').find('a[name=LoadingIcon]');
                loader.removeClass('hide-icon');
                loader.find('i').addClass('fa-spin fa-spinner');
                var target = $('#DisableReviewProcess').attr('data-target');
                this.SaveData(input, input, target);
            });
        });
        $('.included-dailyreport').each((i, e) => {
            var input = $(e).find('input[type=checkbox]');
            if (input.hasClass('select-all-items'))
                return;
            input.change((event) => {
                input.prop('disabled', true);
                var loader = input.closest('tr').find('a[name=LoadingIcon]');
                loader.removeClass('hide-icon');
                loader.find('i').addClass('fa-spin fa-spinner');
                var target = $('#EnableDailyReports').attr('data-target');
                this.SaveData(input, input, target);
            });
        });
    }
    toggleIncludedCheckbox() {
        $('.auto-save').find('.grid-wrapper').each((i, e) => {
            if (($(e).find('input[type=checkbox]').not('.select-all-items').not(':checked').length > 0) == false) {
                $(e).find('input[type=checkbox]').not('.checkbox').prop('checked', true);
            }
            else {
                $(e).find('input[type=checkbox]').not('.checkbox').prop('checked', false);
            }
        });
    }
    invokeActionWithAjax(event, actionUrl, syncCall = false) {
        return super.invokeActionWithAjax(event, actionUrl, syncCall = false);
    }
    hidePleaseWait() {
        $('button i.fa-spinner.fa-spin').removeClass('fa-spinner fa-spin').addClass('fa-check');
        super.hidePleaseWait();
    }
    showPleaseWait() {
        super.showPleaseWait(true);
    }
    //stop th headers being clicked a super amount of time
    toggleClickabilityOfHeader() {
        $('form[data-module=AMPItemList]').find('th').each((i, e) => {
        });
    }
    // Here you can override any of the base standard functions.
    // e.g: To use a different AutoComplete library, simply override handleAutoComplete(input).
    selectAllCheckbox() {
        $('.included-checkbox').each((i, e) => {
            var input = $(e).find('input[type=checkbox]');
            if (!input.hasClass('select-all-items'))
                return;
            var selectAllCheckbox = input;
            var containerGroup = selectAllCheckbox.closest('.grid-wrapper');
            selectAllCheckbox.change((event) => {
                selectAllCheckbox.prop('disabled', true);
                var loader = containerGroup.find('th[class=loading]').find('a[name=LoadingIcon]');
                loader.removeClass('hide-icon');
                loader.find('i').addClass('fa-spin fa-spinner');
                var checkBoxes = containerGroup.find('input[type=checkbox]').not(selectAllCheckbox);
                var target = selectAllCheckbox.attr("data-target");
                this.SaveData(checkBoxes, selectAllCheckbox, target);
            });
        });
    }
    SaveData(checkBoxes, selectAllCheckbox, target) {
        var isChecked = selectAllCheckbox.prop('checked');
        var link = '/' + target + '/include';
        var ids = [];
        checkBoxes.each((i, e) => ids.push(e.getAttribute('data-id')));
        $.post(link, {
            ids: ids,
            value: isChecked,
        }, () => {
            checkBoxes.each(function () {
                $(this).prop('checked', isChecked);
            });
            if (checkBoxes.length == 1) {
                var loadingIcon = checkBoxes.closest('tr').find('a[name=LoadingIcon]');
                loadingIcon.addClass('hide-icon');
                loadingIcon.find('i').removeClass('fa-spin fa-spinner');
            }
            else {
                var containerGroup = selectAllCheckbox.closest('.grid-wrapper');
                var loader = containerGroup.find('th[class=loading]').find('a[name=LoadingIcon]');
                loader.addClass('hide-icon');
                loader.find('i').removeClass('fa-spin fa-spinner');
            }
            selectAllCheckbox.prop('disabled', false);
        });
    }
    renderPieChart(element, labels, data) {
        var ctx = document.getElementById(element);
        new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                        data: data,
                        backgroundColor: this.backgroundColors,
                        borderColor: this.borderColors,
                        borderWidth: 1
                    }]
            },
            options: {
                animation: {
                    duration: 0
                },
                legend: {
                    position: "right"
                }
            }
        });
    }
    renderBarChart(element, labels, data) {
        var barctx = document.getElementById(element);
        var myBarChart = new Chart(barctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        data: data,
                        backgroundColor: this.backgroundColors,
                        borderColor: this.borderColors,
                        borderWidth: 1
                    }
                ]
            },
            options: {
                animation: {
                    duration: 0
                },
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                }
            }
        });
    }
    renderLineChart(element, labels, data) {
        var linectx = document.getElementById(element);
        var myLineChart = new Chart(linectx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        lineTension: 0,
                        data: data,
                        borderColor: "rgba(54, 162, 235, 1)",
                        borderWidth: 1,
                        fill: false
                    }
                ]
            },
            options: {
                animation: {
                    duration: 0
                },
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }]
                }
            }
        });
    }
}
page = new ApplicationPage();
//# sourceMappingURL=application.page.js.map